<template>
  <main>
    <!-- Start Banner-->
    <div class="banner">
      <div class="banner__background"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="banner__introduction">
              <div class="banner__introduction-title" data-aos="fade-up">TIMEBIRD</div>
              <div class="banner__introduction-text" data-aos="fade-up">
                <p>Formerly known as Research and Development Center of Techcom, TimeBird Joint Stock Company was established on 8 Jun 2020 with the mission of applying high technology in order to support digital transformation into Trade and Investment.</p>
                <p>Over the last one year, under the leadership and management of CEO and CTO Thanh Hai Nguyen, TimeBird has achieved a scale of 50-100 high-quality employees. IT professionals and technicians account for 80% personnel resources. In addition, TimeBird quickly becomes a reputable and reliable partner of many domestic and foreign companies and customers.</p>
              </div>
              <div class="banner__introduction-button">
                <a href="javascript:;" @click.prevent="scrollToElement"><img class="mx-auto" src="/assets/images/icons/long-arrow-down.svg" alt="icon"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner-->
    <!-- Start Introduction-->
    <div class="introduction home" data-aos="fade-up" data-aos-delay="500" ref="scrollToMe">
      <div class="container">
        <div class="introduction__box">
          <div class="introduction__box-item">
            <div class="item__image"><img src="/assets/images/home/introduction-icon-01.png" alt="icon"></div>
            <div class="item__content">
              <div class="item__content-title">Our Vision</div>
              <div class="item__content-text">Pioneering in providing technological solutions to help producing, investing and trading activities to take place quickly with high degree of accuracy and security.</div>
            </div>
          </div>
          <div class="introduction__box-item">
            <div class="item__image"><img src="/assets/images/home/introduction-icon-02.png" alt="icon"></div>
            <div class="item__content">
              <div class="item__content-title">Our Mission</div>
              <div class="item__content-text">Creating applications and technological ecosystem assisting customers to manage business activities and assets easily, real-time and safely.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Introduction-->
    <!-- Start Core Values -->
    <div class="section">
      <div class="container">
        <div class="section__content">
          <div class="section__content-title" data-aos="fade-right">
            Core Values
            <span data-aos="fade-left" data-aos-delay="300"></span>
          </div>
          <div class="section__content-subtitle" data-aos="fade-right">Guide for all thoughts and activities of TimeBird</div>
        </div>
      </div>
      <div class="container custom">
        <swiper :options="coreOption" class="swiper__core section__slide" data-aos="fade-up">
          <template v-for="(item, index) in listCore">
            <swiper-slide :key="index" class="section__slide-item">
              <div class="item__icon">
                <img :src="`/assets/images/home/${item.icon}.png`" alt="icon">
              </div>
              <div class="item__title">{{ item.title }}</div>
            </swiper-slide>
          </template>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- End Core Values -->
    <!-- Start Field Operations -->
    <div class="section">
      <div class="container">
        <div class="section__content">
          <div class="section__content-title" data-aos="fade-right">
            Field Operations
            <span data-aos="fade-left" data-aos-delay="300"></span>
          </div>
        </div>
      </div>
      <div class="container custom">
        <swiper :options="fieldOption" class="swiper__field section__slide" data-aos="fade-up">
          <template v-for="(item, index) in listField">
            <swiper-slide :key="index" class="section__slide-item">
              <div class="item__icon">
                <img :src="`/assets/images/home/${item.icon}.png`" alt="icon">
              </div>
              <div class="item__title">{{ item.title }}</div>
            </swiper-slide>
          </template>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- End Field Operations -->
    <!-- Start Internal Activities -->
    <div class="section">
      <div class="container">
        <div class="section__content">
          <div class="section__content-title" data-aos="fade-right">
            Internal Activities
            <span data-aos="fade-left" data-aos-delay="300"></span>
          </div>
          <div class="section__content-subtitle" data-aos="fade-right">If an environment can satisfy both "material" and "spiritual" aspects, it is a desirable working environment which helps self-generating feelings of wanting to devote and stick together for a long time. Therefore, TimeBird always focuses on balancing both aspects for its employees.</div>
        </div>
        <div class="section__box">
          <div class="row">
            <div class="col-md-6">
              <div class="section__box-item">
                <div class="item__image" data-aos="fade-right">
                  <img src="/assets/images/home/internal-actives-01.jpg" alt="internal-actives">
                </div>
                <div class="item__title" data-aos="fade-up">Personal Objectives</div>
                <div class="item__subtitle" data-aos="fade-up">Reach the long-term career objective step by step</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="section__box-item">
                <div class="item__image" data-aos="fade-left">
                  <img src="/assets/images/home/internal-actives-02.jpg" alt="internal-actives">
                </div>
                <div class="item__title" data-aos="fade-up">Internal Training</div>
                <div class="item__subtitle" data-aos="fade-up">Become guru together</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="section__box-item">
                <div class="item__image" data-aos="fade-right">
                  <img src="/assets/images/home/internal-actives-03.jpg" alt="internal-actives">
                </div>
                <div class="item__title" data-aos="fade-up">Teabreak And Monthly Party</div>
                <div class="item__subtitle" data-aos="fade-up">Work hard play hard</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="section__box-item">
                <div class="item__image" data-aos="fade-left">
                  <img src="/assets/images/home/internal-actives-04.jpg" alt="internal-actives">
                </div>
                <div class="item__title" data-aos="fade-up">Sports</div>
                <div class="item__subtitle" data-aos="fade-up">Be strong be free-mind</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <!-- End Internal Activities -->
  </main>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      listCore: [
        { icon: 'core-icon-01', title: 'Transparent' },
        { icon: 'core-icon-02', title: 'Security' },
        { icon: 'core-icon-03', title: 'Integrity' },
        { icon: 'core-icon-04', title: 'Respectful' },
        { icon: 'core-icon-05', title: 'Tolerant' },
        { icon: 'core-icon-06', title: 'Uncompromising' },
        { icon: 'core-icon-07', title: 'Effort' },
      ],
      listField: [
        { icon: 'field-icon-01', title: 'Exchange Platform' },
        { icon: 'field-icon-02', title: 'IT - Specialized Training' },
        { icon: 'field-icon-03', title: 'Research and Technology Transfer' },
        { icon: 'field-icon-04', title: 'Management Software' },
        { icon: 'field-icon-05', title: 'Outsourcing' },
      ],
      coreOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          375: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 5,
          },
          1440: {
            slidesPerView: 7,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      fieldOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          375: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 5,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
  },
  methods: {
    scrollToElement() {
      const el = this.$refs.scrollToMe
      if (el) {
        el.scrollIntoView({behavior: 'smooth'})
      }
    },
  },
}
</script>
